// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductAllergyInformation_container__P_mhP","heading":"ProductAllergyInformation_heading__p6_4Q"};